import { ca } from '@cian/analytics';

export const trackMorePhotosByDateClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BuildingProgress_JK',
    pageType: 'BuildingProgressJK',
    action: 'show_more_photos',
    label: 'by_date',
  });
};
